import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RiverDelta1TerrainTileEntity extends TileEntity {
	public static readonly frameName = FrameName.RIVER_DELTA1;
}

export default RiverDelta1TerrainTileEntity;
